import { ServiceMode } from 'generated/graphql-gateway';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useServiceModeContext } from 'state/service-mode';

export const useIsVehicleDescriptionEnabled = (): boolean => {
  const { serviceMode } = useServiceModeContext();
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );

  return (
    (serviceMode === ServiceMode.DRIVE_THRU && isMobileOrderForDriveThruLaneEnabled) ||
    serviceMode === ServiceMode.MOBILE_ORDER_DRIVE_THRU
  );
};
